export default "__VITE_ASSET__Bn6FuR1D__"